import Navbar from './NavBar'
export default Navbar
